import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BuildingIcon, GlassWaterIcon, ChefHatIcon } from 'lucide-react';
export function FacilityBookingExcerpt({
  onViewMore
}: {
  onViewMore: () => void;
}) {
  return <section className="w-full bg-[#A68B39] py-24 px-6 relative overflow-hidden" data-id="element-16">
      {/* Background Image Overlay */}
      <div className="absolute inset-0 z-0 opacity-5 pointer-events-none mix-blend-multiply" data-id="element-17">
        <img src="https://cdn.magicpatterns.com/uploads/taRUXEm7G7W1bgNVU3GzZ2/WhatsApp-Image-2026-06-16-at-10.13.26-AM.jpg" alt="" className="w-full h-full object-cover grayscale" data-id="element-18" />
      </div>
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-19">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-20">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-21">
            <span className="font-inter text-xs tracking-[0.4em] text-[#050505]/60 uppercase" data-id="element-22">
              Private Events
            </span>
            <h2 className="font-montserrat font-black text-4xl sm:text-5xl tracking-widest text-[#050505] mt-2 mb-6" data-id="element-23">
              FACILITY BOOKING
            </h2>
            <div className="w-16 h-px bg-[#050505]/30 mb-6" data-id="element-24" />
            <p className="font-inter font-light text-[#050505]/70 text-lg leading-relaxed mb-8" data-id="element-25">
              MK Lounge on U is a modern lounge with 2 floors. With 2 fully
              stocked bars, one on each floor, we are equipped to handle most
              events including corporate gatherings. We also feature a full
              kitchen to cater to your guests' needs.
            </p>
            <button onClick={onViewMore} className="group flex items-center gap-3 font-montserrat font-700 text-xs tracking-widest bg-[#050505] text-[#A68B39] px-8 py-4 rounded-xl hover:bg-[#1a1a1a] transition-all duration-300" style={{
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }} data-id="element-26">
              VIEW DETAILS
              <ArrowRightIcon size={14} className="group-hover:translate-x-1 transition-transform" data-id="element-27" />
            </button>
          </motion.div>

          {/* Visual / Features Grid */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-28">
            {[{
            icon: <BuildingIcon size={24} data-id="element-29" />,
            title: '2 FLOORS',
            desc: 'Spacious modern layout'
          }, {
            icon: <GlassWaterIcon size={24} data-id="element-30" />,
            title: '2 BARS',
            desc: 'Fully stocked on each level'
          }, {
            icon: <ChefHatIcon size={24} data-id="element-31" />,
            title: 'FULL KITCHEN',
            desc: 'Complete catering available'
          }, {
            icon: <BuildingIcon size={24} data-id="element-32" />,
            title: 'ANY EVENT',
            desc: 'Perfect for corporate events'
          }].map((feature, idx) => <div key={idx} className="bg-[#050505]/5 border border-[#050505]/10 rounded-2xl p-6 hover:border-[#050505]/30 transition-colors group" data-id="element-33">
                <div className="w-12 h-12 rounded-xl bg-[#050505]/10 flex items-center justify-center text-[#050505] mb-4 group-hover:scale-110 transition-transform" data-id="element-34">
                  {feature.icon}
                </div>
                <h3 className="font-montserrat font-black text-sm tracking-widest text-[#050505] mb-1" data-id="element-35">
                  {feature.title}
                </h3>
                <p className="font-inter text-xs text-[#050505]/50" data-id="element-36">
                  {feature.desc}
                </p>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}